
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// PublishPost
// PUBLISHPOST
const GETALLCITIESBYSTATE= createAsyncThunk(
  "getAllCitiesByState/getAllCitiesByState",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllCitiesByStateSlice = createSlice({
  name: "getAllCitiesByStateSlice",
  initialState: {
    getAllCitiesByState: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllCitiesByState: (state) => {
        state.getAllCitiesByState.loading = false
        state.getAllCitiesByState.error = false
        state.getAllCitiesByState.data = []
        state.getAllCitiesByState.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCITIESBYSTATE.fulfilled, (state, action) => {
      state.getAllCitiesByState = {
        ...state.getAllCitiesByState,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCITIESBYSTATE.pending, (state, action) => {
      state.getAllCitiesByState = {
        ...state.getAllCitiesByState,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCITIESBYSTATE.rejected, (state, action) => {
      state.getAllCitiesByState = {
        ...state.getAllCitiesByState,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllCitiesByStateAction = {
    GETALLCITIESBYSTATE,
};

export { getAllCitiesByStateAction };
export default getAllCitiesByStateSlice.reducer;
export const {setInitialStateOfgetAllCitiesByState} = getAllCitiesByStateSlice.actions
